import { createAction, createReducer } from '@reduxjs/toolkit';
import UtmTracking from 'types/UtmTracking';

const firstVisitTrackingReceived = createAction<UtmTracking>('firstVisitTracking/received');

const firstVisitTrackingReducer = createReducer(
  {},
  {
    [firstVisitTrackingReceived.type]: (state, action) => {
      return action.payload;
    },
  }
);

export { firstVisitTrackingReducer, firstVisitTrackingReceived };
